import React, { useState, useRef } from 'react';
import { User, Camera, Trash2 } from 'lucide-react';
import Button from '../../../shared/components/Button';
import Card from '../../../shared/components/Card';

const AvatarUpload = ({ avatar, onUpload, onRemove, uploading }) => {
  const [preview, setPreview] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      // Preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreview(reader.result);
      };
      reader.readAsDataURL(file);
      
      // Upload
      onUpload(file);
    }
  };

  const handleRemove = () => {
    setPreview(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    onRemove();
  };

  return (
    <Card className="p-6">
      <div className="flex flex-col items-center space-y-4">
        <div className="relative">
          <div className="w-32 h-32 rounded-full overflow-hidden bg-gray-100 border-4 border-white shadow-lg">
            {preview || avatar ? (
              <img
                src={preview || avatar}
                alt="Profile"
                className="w-full h-full object-cover"
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center bg-gray-200">
                <User size={48} className="text-gray-400" />
              </div>
            )}
          </div>
          
          <label
            htmlFor="avatar-upload"
            className="absolute bottom-0 right-0 bg-blue-600 text-white p-2 rounded-full cursor-pointer hover:bg-blue-700 transition-colors"
          >
            <Camera size={16} />
            <input
              ref={fileInputRef}
              id="avatar-upload"
              type="file"
              accept="image/*"
              className="hidden"
              onChange={handleFileChange}
              disabled={uploading}
            />
          </label>
        </div>

        {uploading && (
          <div className="text-sm text-gray-500">Uploading...</div>
        )}

        {avatar && (
          <Button
            variant="danger"
            size="sm"
            onClick={handleRemove}
            disabled={uploading}
          >
            <Trash2 size={16} className="mr-2" />
            Remove Photo
          </Button>
        )}
      </div>
    </Card>
  );
};

export default AvatarUpload;